import { useEffect, useState } from "react";
import { Nonprofit } from "~/models/list";
import { getWtgnList } from "~/common/api/list";

/**
 * hook to fetch a WTGN list whenever the listId or randomize changes
 *
 * @param listId - string representing list id
 * @param randomize - boolean representing whether to randomize the list
 * @returns - an array containing the WTGN list of nonprofits
 */
export const useWTGNList = (
  listId: string | undefined | null,
  randomize: boolean,
): [Nonprofit[] | undefined, boolean] => {
  const [list, setList] = useState<Nonprofit[]>();
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    async function fetchList(
      listId: string | undefined | null,
      randomize: boolean,
    ) {
      setList(undefined);

      if (listId) {
        // console.log("props.listId", props.listId);
        const results = await getWtgnList(Number(listId), randomize).catch(
          (error) => {
            console.error("ListView: Error fetching nonprofits", error);
            setIsError(true);
          },
        );

        setList(results || []);
      }
    }

    fetchList(listId, randomize);
  }, [listId, randomize]);

  return [list, isError];
};
